import installUL from '@redturtle/volto-io-studio/config/Slate/UnorderdList';
import installLinkButton from '@redturtle/volto-io-studio/config/Slate/LinkButton';

import installHR from '@redturtle/volto-io-studio/config/Slate/Hr';
import installTextMargin from '@redturtle/volto-io-studio/config/Slate/TextMargin';

export default function applyIoStudioSlateConfig(config) {
  installUL(config);
  installLinkButton(config);
  installHR(config);
  installTextMargin(config);
  return config;
}
